import { Flask } from "@phosphor-icons/react"

import { isProduction } from "~/utils/environment"

const prototypeIcon = (color: string) => <Flask className="cursor-pointer" color={color} />

export type PrototypeSidebarContext = {
  isStaff: boolean
  showInternalFeatures: boolean
}

/** Prototype nav entries live here so `useSidebarItems` stays stable across prototype PRs. */
export function getPrototypeSidebarItem(ctx: PrototypeSidebarContext) {
  return {
    name: "Prototypes",
    pathName: "/prototype",
    icon: prototypeIcon,
    exclude: !ctx.isStaff || isProduction() || !ctx.showInternalFeatures,
    section: "Internal",
    subItems: [
      {
        name: "Seasons and collections",
        pathName: "/prototype/seasons-collections",
        icon: prototypeIcon,
        disabled: isProduction(),
      },
    ],
  }
}
